const topics = [
  { id: 1, tag: '#春日华尔兹大结局', heat: '312万', isHot: true },
  { id: 2, tag: '#日剧推荐2026', heat: '287万', isHot: true },
  { id: 3, tag: '#韩剧OST封神', heat: '256万', isHot: true },
  { id: 4, tag: '#悬疑剧反转', heat: '198万', isHot: false },
  { id: 5, tag: '#古装韩剧天花板', heat: '176万', isHot: false },
  { id: 6, tag: '#周末追剧清单', heat: '154万', isHot: false },
  { id: 7, tag: '#日剧治愈系', heat: '132万', isHot: false },
  { id: 8, tag: '#韩剧男神回归', heat: '118万', isHot: false },
  { id: 9, tag: '#深夜剧推荐', heat: '95万', isHot: false },
  { id: 10, tag: '#漫改日剧', heat: '83万', isHot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            热门话题
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            日韩剧迷热议话题速递，参与讨论分享你的追剧心得
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#comments"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                topic.isHot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200 border border-primary-200/60'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200 border border-background-200/40'
              }`}
            >
              {topic.isHot && (
                <i className="ri-fire-line text-accent-500 text-sm"></i>
              )}
              <span>{topic.tag}</span>
              <span className="text-xs opacity-60">{topic.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}